if (!customElements.get('header-close')) {
  class HeaderClose extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        this.closest('details')?.querySelector('summary')?.click();
      });
    }
  }

  customElements.define('header-close', HeaderClose);
}
